// Puente con el Dock del chat (chat-app.js del portal actual: openContactSession, openContactConversation y
// revalidateContactScope). El Dock (chat/browser.ts) escucha «bheli:dock-contact» en window y deja en detail.result la
// promesa con lo que hizo; así Contactos no carga el chat en su propio archivo. Sin Dock, abrir devuelve false, como
// cuando el portal actual no tiene su Dock: la pantalla muestra «no disponible».

type DockRequest = {
  kind: "session" | "conversation" | "scope";
  id: number;
  canOpenChat?: boolean;
  result: Promise<boolean> | null;
};

function ask(request: Omit<DockRequest, "result">): Promise<boolean> {
  const detail: DockRequest = { ...request, result: null };
  window.dispatchEvent(new CustomEvent("bheli:dock-contact", { detail }));
  return detail.result ?? Promise.resolve(false);
}

/** Abre en el Dock una sesión existente y autorizada del contacto. */
export async function openContactSession(session: number): Promise<boolean> {
  if (!Number.isSafeInteger(session) || session <= 0) return false;
  try {
    return await ask({ kind: "session", id: session });
  } catch {
    return false;
  }
}

/** Abre en el Dock la conversación del contacto. */
export async function openContactConversation(conversation: number): Promise<boolean> {
  if (!Number.isSafeInteger(conversation) || conversation <= 0) return false;
  try {
    return await ask({ kind: "conversation", id: conversation });
  } catch {
    return false;
  }
}

/** Avisa al Dock que el alcance de Contactos cambió. */
export async function revalidateContactScope(canOpenChat: boolean): Promise<void> {
  try {
    await ask({ kind: "scope", id: 0, canOpenChat });
  } catch {
    /* El Dock decide con su propio contexto. */
  }
}
